import React, { FC, useMemo } from 'react';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import PartsTagDisplay from '../TagDisplay/PartsTagDisplay';

const PartWithIDDisplay: FC<any> = ({
	part,
	numberMaxChars,
	nameLengthPercentage,
	hideAliasNumber,
}): React.ReactElement => {
	const ellipsisProps = useMemo(
		() => ({
			...(numberMaxChars ? { length: numberMaxChars } : { lines: 1 }),
		}),
		[numberMaxChars]
	);

	const partNumberText = useMemo(
		() =>
			`${nullSafeGet('partNumber', part) ? `Part # ${part.partNumber} ` : ''}${
				nullSafeGet('aliasPartId', part) && !hideAliasNumber
					? `Alias Part # ${part.aliasPartId}`
					: ''
			}`,
		[hideAliasNumber, part]
	);

	return (
		<div
			className="flex flex-col gap-y-1"
			style={{
				...(nameLengthPercentage && { width: `${nameLengthPercentage}%` }),
			}}
		>
			<Ellipsis tooltip={true} lines={1} className="bodymedium">
				{part.name}
			</Ellipsis>
			<Ellipsis tooltip={true} className="bodyregular text-gray-400" {...ellipsisProps}>
				{partNumberText}
			</Ellipsis>
			<PartsTagDisplay className="gap-y-1" tags={nullSafeGetOrElse('tags', part, [])} />
		</div>
	);
};

export default PartWithIDDisplay;
